module.exports = __webpack_public_path__ + "static/media/Arrowup.78f6c536.svg";